import { FC } from 'react'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType } from 'src/Types/ui'
import {
  AdCampaignStrategyEnum,
  AdCampaignVisualTypeEnum,
  AdVisualDescriptionQuestion,
} from 'src/Redux/ad-campaignApi'
import { useUpdateMetaAdsCampaignMutation } from 'src/Redux/adsCampaignApi'
import { ApiError } from 'src/Redux/types'

import { AdsGenresModalsWrapper } from '../AdsGenresModalsWrapper'
import { AdsArtistsModal } from '../AdsArtistsModal'
import { AdsCountriesModal } from '../AdsCountriesModal'
import { AdsVisualModal } from '../AdsVisualModal'
import { VisualFormData } from '../AdsVisualModal/AdsVisualModalContent'
import { AdsLanguagesModal } from '../AdsLanguagesModal'
import { AdsPlacementsModal } from '../AdsPlacementsModal'

interface AdsScheduleModalsProps {
  visualQuestions?: AdVisualDescriptionQuestion[] | null
  strategyType?: AdCampaignStrategyEnum
  campaignId: number
  visualType?: AdCampaignVisualTypeEnum
}

export const AdsScheduleModals: FC<AdsScheduleModalsProps> = ({
  visualQuestions,
  strategyType,
  campaignId,
  visualType,
}) => {
  const { search, setSearch } = useCustomSearchParams()

  const [updateMetaAdsCampaign] = useUpdateMetaAdsCampaignMutation()

  const handleSaveVisualData = async (
    visualFormData: VisualFormData,
    callback: (error: ApiError | null) => void,
  ): Promise<void> => {
    const { visualType: selectedVisualType, ...answers } = visualFormData

    const questions: AdVisualDescriptionQuestion[] = Object.entries(answers)
      .filter(
        ([, answer]) => typeof answer === 'string' && answer.trim() !== '',
      )
      .map(([question, answer]) => ({
        question,
        answer: answer as string,
      }))

    try {
      await updateMetaAdsCampaign({
        id: campaignId,
        adVisualDescription: questions.length > 0 ? questions : void 0,
        visualType: selectedVisualType,
      }).unwrap()

      setSearch({ modal: null })
    } catch (error) {
      callback(error as ApiError)
    }
  }

  const onSaveVisualData = (visualFormData: VisualFormData): void => {
    handleSaveVisualData(visualFormData, () => {})
  }

  if (search.get('modal') === ModalType.Genres) {
    return <AdsGenresModalsWrapper />
  }

  if (search.get('modal') === ModalType.Artists) {
    return <AdsArtistsModal />
  }

  if (search.get('modal') === ModalType.Countries) {
    return <AdsCountriesModal />
  }

  if (search.get('modal') === ModalType.Languages) {
    return <AdsLanguagesModal />
  }

  if (search.get('modal') === ModalType.AdVisual) {
    return (
      <AdsVisualModal
        visualQuestions={visualQuestions}
        strategyType={strategyType}
        visualType={visualType}
        onSaveVisualData={onSaveVisualData}
      />
    )
  }

  if (search.get('modal') === ModalType.AdsPlacements) {
    return <AdsPlacementsModal />
  }

  return null
}
